import React, { useMemo } from "react";

import pluralize from "pluralize";

import { Typography, SearchBar } from "clearsense-ui/components";

import ColumnSelect from "./ColumnSelect";

const ActionHeader = ({
  result,
  search,
  setSearch,
  columns,
  toggleVisibility,
}) => {
  const fileCount = useMemo(
    () =>
      result?.reduce((acc, document) => {
        if (document.children) return acc + document.children.length;

        return document.isDir ? acc : acc + 1;
      }, 0),
    [result]
  );

  return (
    <div className="flex justify-between mt-4 mb-8">
      <div className="flex items-center gap-3">
        <Typography style="large" type="bold">
          {fileCount > 0 && pluralize("Documents", fileCount, true)}
        </Typography>
      </div>
      <div className="flex gap-2">
        <SearchBar
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search Documents"
        />
        <ColumnSelect columns={columns} toggleVisibility={toggleVisibility} />
      </div>
    </div>
  );
};

export default ActionHeader;
